import { render, staticRenderFns } from "./certified_list.vue?vue&type=template&id=dc6dd68c&scoped=true"
import script from "./certified_list.vue?vue&type=script&lang=ts"
export * from "./certified_list.vue?vue&type=script&lang=ts"
import style0 from "./certified_list.vue?vue&type=style&index=0&id=dc6dd68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6dd68c",
  null
  
)

export default component.exports